import { getFirestore, doc, updateDoc, Timestamp } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Import storage functions
import { app } from "../config";

const db = getFirestore(app);
const storage = getStorage(app); // Initialize Firebase Storage

// Define the function to update the EOBusinessProfiles
const updateEOBusinessProfile = async (documentId, EO) => {
  try {
    let companyLogoUrl = EO.companyLogo;

    // Check if companyLogo is a File object
    if (EO.companyLogo instanceof File) {
      const timestamp = new Date().toISOString();
      const file = EO.companyLogo;
      const fileName = `${file.name}_${timestamp}`;
      const logoRef = ref(storage, `businessProfiles/${documentId}/company_logos/${fileName}`);
      await uploadBytes(logoRef, EO.companyLogo);
      companyLogoUrl = await getDownloadURL(logoRef);
    }

    const updatedEO = {
      ...EO,
      companyLogo: companyLogoUrl,
      updatedAt: Timestamp.now(),
    };

    const docRef = doc(db, "EO_BusinessProfiles", documentId);

    await updateDoc(docRef, updatedEO);

    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
};

export { updateEOBusinessProfile };
